/**
 * Settings Page
 * Configurações do sistema
 */
import { Settings as SettingsIcon, Bell, Shield, Globe, Database, Mail } from 'lucide-react'

export default function Settings() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-white">Configurações</h1>
        <p className="text-slate-400">Configurações gerais do sistema</p>
      </div>
      
      <div className="grid grid-cols-2 gap-6">
        {[
          { icon: Globe, title: 'API & Integrações', desc: 'Configurar APIs e webhooks' },
          { icon: Bell, title: 'Notificações', desc: 'Alertas e canais de comunicação' },
          { icon: Shield, title: 'Segurança', desc: 'Políticas de acesso e 2FA' },
          { icon: Database, title: 'Banco de Dados', desc: 'Backups e manutenção' },
          { icon: Mail, title: 'Email', desc: 'Configurar SMTP e templates' },
          { icon: SettingsIcon, title: 'Geral', desc: 'Configurações do sistema' },
        ].map((item) => (
          <div key={item.title} className="admin-card hover:border-violet-500/30 transition-colors cursor-pointer">
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-xl bg-violet-500/10 border border-violet-500/20">
                <item.icon className="w-6 h-6 text-violet-400" />
              </div>
              <div>
                <h3 className="font-semibold text-white">{item.title}</h3>
                <p className="text-sm text-slate-400">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

